<template>
  <layout-admin-dashboard-view
    :show-toolbar="false"
    :back-route="{ name: 'admin' }">
    <template #title>
      <span>{{ translateTitleCase("lp.admin.lpList.title") }}</span>
    </template>

    <template #default>
      <custom-crud-list v-bind="listConfiguration">
        <template #cell-state="{ item }">
          <span v-if="item.state" class="c-success">
            <icon icon="check"></icon>
          </span>
          <span v-else class="c-error">
            <icon icon="x"></icon>
          </span>
        </template>
        <template #cell-CategoryId="{ item }">
          <span>{{ item.Category ? item.Category.name : "-" }}</span>
        </template>
      </custom-crud-list>
    </template>
  </layout-admin-dashboard-view>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations";
import CustomCrudList from "@/client/components/crud/customV1/List.vue";

export default {
  components: { CustomCrudList },
  layout: "adminDashboard",
  middleware: {
    requireSuperAdmin: {},
  },
  props: {},
  setup(props) {
    let { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations(props);
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: "lp.admin.lpList.pageTitle",
  data: function () {
    return {
      listConfiguration: {
        subject: "landingPage",
        listSrc: "landingPage",
        showIdField: true, // bool deafult true
        sortable: false, //bool, default false
        publishable: true, //bool, default false
        enableMassActions: true,
        editRoutePrefix: "admin-",
        createRoutePrefix: "admin-",
        deleteRoutePrefix: "",
        additionalListData: {
          simplified: false,
          translate: false,
        },
        fields: {
          // these are the table columns
          title: {
            itemKey: "title",
            label: "lp.lpModel.fields.title",
            filterable: true, // boolean, or object
            orderable: true,
          },
          alias: {
            itemKey: "alias",
            label: "lp.lpModel.fields.alias",
            filterable: true, // boolean, or object
            orderable: true,
          },
          CategoryId: {
            itemKey: "CategoryId",
            label: "lp.lpModel.fields.category",
            filterable: {
              name: "CategoryId",
              type: "Select2",
              translateList: false,
              valueKey: "id",
              labelKey: "name",
              placeholder: "lp.lpModel.fields.category",
              itemComponent: "iconItem",
              asyncListSource: "entity/Category",
              asyncListLive: false,
              textFilterAsSaffronListFilter: true,
              asyncDataTextFilterParamName: "title",
              multiple: false,
              asyncListData: {
                simplified: true,
              },
            }, // boolean, or object
          },
          state: {
            itemKey: "state",
            label: "core.entity.state",
            placeholder: "core.entity.state",
            filterable: {
              name: "state",
              type: "select2",
              list: [
                { value: 0, label: "core.entity.stateValues.0" },
                { value: 1, label: "core.entity.stateValues.1" },
              ],
            }, // boolean, or object
            orderable: true,
            quickEdit: {
              type: "binaryInteger",
            },
          },
        },
        actions: {
          show: false,
          edit: true,
          delete: true,
          custom: {
            preview: {
              //tooltip
              tooltip: { content: "lp.admin.preview.actionTooltip" },
              icon: "eye",
              theme: "inverse",
              show: (item) => {
                return true;
              },
              handler: async ({ item }) => {
                let name = `landing-categoryAlias-lpAlias`;
                let params = {
                  categoryAlias: item?.Category?.alias,
                  lpAlias: item?.alias,
                };
                let query = {
                //  isPreview: true,
                };

                let resolved = this.$router.resolve({ name, params, query });
                window.open(resolved.href, "_blank");
              },
            },
          },
        },
        asyncData: {},
      },
    };
  },
};
</script>

<style scoped lang="scss"></style>
